import { formatter, request } from "@/utils/request";

export namespace ProductPolicy {
  export const Path = {
    Get: '/expenseapi/productPolicy/get',
    GetVo: '/expenseapi/productPolicy/getVo',
    GetHistoryVo: '/expenseapi/productPolicy/getHistoryVo',
    GetRebatePolicySize: '/expenseapi/productPolicy/getRebatePolicySize',
    GetPolicyOpenMode: '/expenseapi/productPolicy/getPolicyOpenMode',
    GetEx: '/expenseapi/productPolicy/getEx',
    Search: '/expenseapi/productPolicy/search',
    AjaxSearch: '/expenseapi/productPolicy/ajaxSearch',
    searchForActivity: '/expenseapi/productPolicy/searchForActivity',
    searchForPicker: '/reportapi/productPolicy/searchForPicker',
    Query: '/expenseapi/productPolicy/query',
    Post: '/expenseapi/productPolicy/post',
    GetProductPolicyTerms: '/expenseapi/productPolicy/getProductPolicyTerms',
    QueryProductPolicySoldTo: '/expenseapi/productPolicy/queryProductPolicySoldTo',
    QueryProductPolicyTarget: '/expenseapi/productPolicy/queryProductPolicyTarget',
    QueryProductPolicySoldToHistory: '/expenseapi/productPolicy/queryProductPolicySoldToHistory',
    QueryProductPolicyTargetHistory: '/expenseapi/productPolicy/queryProductPolicyTargetHistory',
    SearchProductPolicyRate: '/expenseapi/productPolicy/searchProductPolicyRate',
    SearchProductPolicyProduct: '/expenseapi/productPolicy/searchProductPolicyProduct',
    SearchProductPolicyProductHistory: '/expenseapi/productPolicy/searchProductPolicyProductHistory',
    SearchProductPolicyRateHistory: '/expenseapi/productPolicy/searchProductPolicyRateHistory',
    GetProductPolicyProducts: '/expenseapi/productPolicy/getProductPolicyProducts',
    SearchProductPolicyHistory: '/expenseapi/productPolicy/searchHistory',
    ExportEx: '/expenseapi/productPolicy/export',
    ExportSoldToEx: '/expenseapi/productPolicy/exportSoldTo',
    searchProductPolicyParameter: '/expenseapi/productPolicy/searchProductPolicyParameter',
    searchProductPolicyResult: '/expenseapi/productPolicy/searchProductPolicyResult',
    getProductPolicyParameter: '/expenseapi/productPolicy/getProductPolicyParameter',
  };

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicy>>(Path.Get, formatter(options));
  }

  export async function getVo(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicyVo>>(Path.GetVo, formatter(options));
  }

  export async function getHistoryVo(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicyHistoryVo>>(Path.GetHistoryVo, formatter(options));
  }
  export async function getRebatePolicySize(productPolicyId: number) {
    const options = {
      method: 'GET',
      body: {
        productPolicyId: productPolicyId,
      },
    };
    return request<API.ResponseResult<Number>>(Path.GetRebatePolicySize, formatter(options));
  }

  export async function getPolicyOpenMode(productPolicyId: number) {
    const options = {
      method: 'GET',
      body: {
        productPolicyId: productPolicyId,
      },
    };
    return request<API.ResponseResult<Number>>(Path.GetPolicyOpenMode, formatter(options));
  }

  export async function ajaxSearch(body: API.ProductPolicySearchFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.ProductPolicy[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function search(body: API.ProductPolicySearchFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.ProductPolicy[]>>(Path.Search, formatter(options));
  }

  export async function searchForActivity(body: API.ProductPolicyFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.ProductPolicyPicker[]>>(Path.searchForActivity, formatter(options));
  }

  export async function searchForPicker(body: API.QueryForPageReq) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.ProductPolicy[]>>(Path.searchForPicker, formatter(options));
  }

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.Query, formatter(options));
  }

  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.ExportEx, formatter(options));
  }


  export async function exportSoldToEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.ExportSoldToEx, formatter(options));
  }


  export async function post(body: API.ProductPolicyPostParam) {
    const options = {
      method: 'POST',
      body: {
        ...body,
      },
    };
    return request<API.ResponseResult<any>>(Path.Post, formatter(options));
  }


  export async function QueryProductPolicySoldTo(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicySoldToQueryPo[]>>(Path.QueryProductPolicySoldTo, formatter(options));
  }

  export async function QueryProductPolicyTarget(productPolicyId: number) {
    const options = {
      method: 'GET',
      body: {
        productPolicyId
      },
    };
    return request<API.ResponseResult<API.ProductPolicyTargetQuery[]>>(Path.QueryProductPolicyTarget, formatter(options));
  }

  export async function QueryProductPolicySoldToHistory(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicyTargetHistoryQuery[]>>(Path.QueryProductPolicySoldToHistory, formatter(options));
  }

  export async function QueryProductPolicyTargetHistory(productPolicyHistoryId: number) {
    const options = {
      method: 'GET',
      body: {
        productPolicyHistoryId
      },
    };
    return request<API.ResponseResult<API.ProductPolicySoldToHistoryQueryPo[]>>(Path.QueryProductPolicyTargetHistory, formatter(options));
  }

  export async function SearchProductPolicyRate(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicyRateVo[]>>(Path.SearchProductPolicyRate, formatter(options));
  }

  export async function SearchProductPolicyProduct(body : API.ProductPolicyProductSearchParam) {
    const options = {
      method: 'POST',
      body: body,
    };
    return request<API.ResponseResult<API.ProductPolicyProductVo[]>>(Path.SearchProductPolicyProduct, formatter(options));
  }

  export async function SearchProductPolicyProductHistory(body : API.ProductPolicyProductSearchParam) {
    const options = {
      method: 'POST',
      body: body,
    };
    return request<API.ResponseResult<API.ProductPolicyProductVo[]>>(Path.SearchProductPolicyProductHistory, formatter(options));
  }

  export async function SearchProductPolicyRateHistory(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicyRateVo[]>>(Path.SearchProductPolicyRateHistory, formatter(options));
  }

  export async function getProductPolicyProducts(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.ProductPolicyProductVo[]>>(Path.GetProductPolicyProducts, formatter(options));
  }


  export async function searchProductPolicyHistory(body: API.ProductPolicyHistorySearchFilter) {
    const options = {
      method: 'Post',
      body: body,
    };
    return request<API.ResponseResult<API.ProductPolicyHistory[]>>(Path.SearchProductPolicyHistory, formatter(options));
  }

  export async function searchProductPolicyParameter(body: API.PolicyParameterSearchParam) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<API.ProductPolicyParameter[]>>(Path.searchProductPolicyParameter, formatter(options));
  }

  export async function searchProductPolicyResult(body: API.ProductPolicyResultSearchParam) {
    const options = {
      method: 'POST',
      body: body
    };
    return request<API.ResponseResult<API.ProductPolicyResultQueryPo[]>>(Path.searchProductPolicyResult, formatter(options));
  }

  export async function getProductPolicyParameter(body:any) {
    const options = {
      method: 'GET',
      body: body
    };
    return request<API.ResponseResult<API.ExpressionTypeParameterVo>>(Path.getProductPolicyParameter, formatter(options));
  }

  export namespace Buttons{

    export const Path={
      validateRebateStandard: '/expenseapi/policyButtons/validateRebateStandard',
      validateProductPolicySoldTo: '/expenseapi/policyButtons/validatePolicySoldTo'
    }

    export async function validateRebateStandard(body:{
      productPolicy:API.ProductPolicy,
      productPolicyRates: API.ProductPolicyRate[]
    }){
      const options = {
        method: 'POST',
        body: body
      };
      return request<any>(Path.validateRebateStandard, formatter(options));
    }

    export async function validateProductPolicySoldTo(param:{
      productPolicySoldTos: API.ProductPolicySoldToQueryPo[];
      productPolicy: any
      currentProductPolicySoldTo: API.ProductPolicySoldToQueryPo;
    }){
      const options = {
        method: 'POST',
        body: param
      };
      return request<any>(Path.validateProductPolicySoldTo, formatter(options));
    }

  }
}
